// extracted by css-extract-rspack-plugin
module.exports =  {"root":"OCRScopingJobSidePanel__root___C9bK8","footer":"OCRScopingJobSidePanel__footer___H_TX7"};